import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const currencyLocaleMap: { [key: string]: string } = {
    'COP': 'es-CO',
    'CLP': 'es-CL',
    'PEN': 'es-PE',
    'PYG': 'es-PY',
    'UYU': 'es-UY',
};

/**
 * A custom hook to get a memoized currency formatter.
 * @param currencyCode - The ISO 4217 currency code (e.g., 'USD', 'COP').
 * @returns An Intl.NumberFormat instance for the given currency.
 */
export const useCurrencyFormatter = (currencyCode: string) => {
    const { i18n } = useTranslation();

    const formatter = useMemo(() => {
        const locale = currencyLocaleMap[currencyCode] || i18n.language || 'en-US';
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode });
    }, [currencyCode, i18n.language]);

    return formatter;
};